import React from 'react';
import {WingBlank, Cols} from '../../components';
import './Advantage.less';

function Advantage({data, lg, md, lm, children, ...props}) {
  return (
    <WingBlank className='Advantage' {...props}>
      <Cols {...{data, lg, md, lm}}>
        {children}
      </Cols>
    </WingBlank>
  );
}

export default Advantage;


// WEBPACK FOOTER //
// ./src/routes/About/Advantage.js